var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"titleDocument"},[_vm._v(" 已有账号，"),_c('a',{on:{"click":_vm.login}},[_vm._v("立即登录")])]),_c('div',{staticClass:"main"},[_c('PlateTitle',{attrs:{"title":"用户注册"}})],1),(!_vm.isSuccess)?_c('Form'):_vm._e(),(_vm.isSuccess)?_c('RegisterSuccess'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }